import {ToastrService} from 'ngx-toastr';
import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {AccessControlService} from 'src/app/services/access-control.service';
import {AlertService} from 'src/app/services/alert.service';
import {Router, ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';
import {AuthConfig, UrlConfig} from '../../model/auth-config.modals';

@Component({
  selector: 'app-application-configuration',
  templateUrl: './application-configuration.component.html',
  styleUrls: ['./application-configuration.component.css']
})

export class ApplicationConfigurationComponent implements OnInit {
  @ViewChild('addapplicationForm') public addapplicationForm: NgForm
  appName: String = '';
  isExtensionError: boolean = false;
  isLogoSizeError: boolean = false;
  logo: any;
  username: string;
  model: AuthConfig = new AuthConfig();
  clientId: string;
  appId: string
  isLoading: boolean;
  isSavingData: boolean = false

  constructor(private accesscontrolService: AccessControlService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private toastrService: ToastrService) {
    this.appId = this.activatedRoute.snapshot.params['id'];
    this.clientId = localStorage.getItem('user_id');
    this.appName = this.activatedRoute.snapshot.queryParams['appname'];
    // this.model = new AuthConfig();
  }

  ngOnInit() {
    this.getApplicationAuthSettings()
  }

  submit() {
    if (!this.addapplicationForm.valid) {
      return
    }
    this.isSavingData = true
    debugger
    this.accesscontrolService.setApplicationAuthSettings(this.clientId, this.appId, this.model).subscribe(
      (result: any) => {
        this.isSavingData = false
        if (!result.error) {
          this.toastrService.success("Setting saved successfully")
          this.router.navigate(['/client-apps'])
        }
      },
      (error: any) => {
        this.isSavingData = false
        var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
        this.toastrService.error(errorMessage)
      }
    )
  }


  getLogoDetails(e) {
    if (e && e.target && e.target.files[0]) {
      this.logo = (e.target.files[0]);
      this.getBase64(this.logo, (result) => {
          this.model.logo = result;
        },
        function (error) {
          console.log('Error: ', error);
        }
      )

      if (e.target.files[0].size > 300 * 1024) {
        this.isLogoSizeError = true;

      } else {
        this.isLogoSizeError = false;
      }
      var ext = this.logo.name.split('.').pop();
      ext = ext.toLowerCase();
      if (ext === 'jpg' || ext === 'jpeg' || ext === "png" || ext === "bmp" || ext === "tiff") {
        this.isExtensionError = false;
      } else {
        this.isExtensionError = true;
      }
    }
  }

  getBase64(file, success, error) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onerror = error;
    reader.onload = () => {
      success(reader.result)
    };
  }

  getApplicationAuthSettings() {
    this.isLoading = true
    this.accesscontrolService.getApplicationAuthSettings(this.clientId, this.appId).subscribe(
      (response: any) => {
        if (!response.error)
          if (response.data) this.model = response.data.auth_config
        if (response.data && response.data.urlInvalid)
          this.model.urlInvalid = response.data.urlInvalid
        else
          this.model.urlInvalid = {
            active: false,
            main_redirect_url: ''
          }
        this.isLoading = false
      },
      (error: any) => {
        this.isLoading = false
        var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
        this.toastrService.error(errorMessage)
      }
    )
  }
}
